import Cookies from 'js-cookie';

const TokenKeyAdmin = 'WZU_Web_4'; // eslint-disable-line

export function getToken() {
  return Cookies.get(TokenKeyAdmin);
}

export function setToken(token) {
  Cookies.set(TokenKeyAdmin, token);
}

export function removeToken() {
  return Cookies.remove(TokenKeyAdmin);
}

export function getCookie(key) {
  return Cookies.get(key);
}

export function setCookie(key, value) {
  Cookies.set(key, value);
}

export function removeCookie(key) {
  return Cookies.remove(key);
}

export function logout() {
  Cookies.remove(TokenKeyAdmin);
  Cookies.remove('wenUsrid');
  Cookies.remove('wenStsid');
  window.localStorage.removeItem('popMessageList');
  window.localStorage.removeItem('language');
}
